import React from "react";

const Main = ({ styles }) => (
  <main className={styles["prototype-main"]} role="main">
    <img className={styles["prototype-image"]} src="https://s3.amazonaws.com/static-asset/prototype-homepage.jpg" alt="" />
  </main>
);

export default Main;
